import { jsx as _jsx } from "react/jsx-runtime";
import { useTrackViewedAsset } from "@air/analytics";
import { useAirModal } from "@air/provider-modal";
import { useShortIdContext } from "@air/provider-short-id";
import { memo, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { usePublicPageViewNotification } from "~/components/AirNotifications/hooks/usePublicPageViewNotification";
import { AssetModal } from "~/components/AssetModal/AssetModal";
import { usePublicAssetClip } from "~/components/PublicAssetModal/hooks/usePublicAssetClip";
import { PublicAssetAnonymousSignUpModal } from "~/components/PublicLinkAnonymousSignUpModal/PublicAssetAnonymousSignUpModal";
import { usePublicSSOAssetCallback } from "~/components/PublicSSOCallback/usePublicSSOAssetCallback";
import { useOnMissingUserSession } from "~/hooks/useOnMissingUserSession";
import { useAccountContext } from "~/providers/AccountProvider";
import { VideoTimeFormatProvider } from "~/providers/VideoTimeFormatProvider";
import { centralizedClipAssetIdSelector, centralizedClipIdSelector, centralizedClipIsDemoSelector } from "~/store/centralizedClip/selectors";
import { PublicAssetModalDesktopLayout } from "./components/PublicAssetModalDesktopLayout";
import { PublicAssetModalMobileLayout } from "./components/PublicAssetModalMobileLayout";
export const PublicAsset = /*#__PURE__*/ memo((param)=>{
    let { initialClip, requireAccount } = param;
    const assetId = useSelector(centralizedClipAssetIdSelector);
    const urlClipId = useSelector(centralizedClipIdSelector);
    const { shortId } = useShortIdContext();
    const isDemo = useSelector(centralizedClipIsDemoSelector);
    const { trackViewedAsset } = useTrackViewedAsset();
    const clipId = urlClipId || initialClip.id;
    const { data: account } = useAccountContext();
    usePublicAssetClip({
        clipId,
        initialData: initialClip
    });
    usePublicSSOAssetCallback();
    const [showAnonymousSignupModal] = useAirModal(PublicAssetAnonymousSignUpModal);
    const { sendPublicPageViewEvent } = usePublicPageViewNotification();
    useOnMissingUserSession({
        onMissingSession: ()=>showAnonymousSignupModal({}),
        enabled: requireAccount
    });
    useEffect(()=>{
        if (!requireAccount || requireAccount && !!account) {
            sendPublicPageViewEvent(shortId);
        }
    }, [
        account,
        requireAccount,
        sendPublicPageViewEvent,
        shortId
    ]);
    useEffect(()=>{
        if (assetId) {
            trackViewedAsset({
                assetId,
                isDemo,
                clip_id: clipId
            });
        }
    }, [
        assetId,
        clipId,
        isDemo,
        trackViewedAsset
    ]);
    const desktop = useMemo(()=>/*#__PURE__*/ _jsx(PublicAssetModalDesktopLayout, {}), []);
    const mobile = useMemo(()=>/*#__PURE__*/ _jsx(PublicAssetModalMobileLayout, {}), []);
    return /*#__PURE__*/ _jsx(VideoTimeFormatProvider, {
        clipId: clipId,
        children: /*#__PURE__*/ _jsx(AssetModal, {
            desktop: desktop,
            mobile: mobile
        })
    });
});
PublicAsset.displayName = "PublicAsset";
